import React from "react";

export const UnauthorizedPage: React.FC = () => {
  return (
    <>
      <h1>401 - Unauthorized</h1>
      <p>
        You have attempted to access a page for which you are not authorized.
      </p>
    </>
  );
};
